import { useState } from "react";
import { SIDEBAR_GRAD } from "../theme";
import { useAuth } from "../auth";
import Icon from "./Icon";
import ChangePassword from "./ChangePassword";

export default function Sidebar({ items, active, onSelect, collapsed, onToggleCollapse }) {
  const { user, logout } = useAuth();
  const [changePw, setChangePw] = useState(false);
  return (
    <aside className={`${collapsed ? "w-[72px]" : "w-60"} shrink-0 flex flex-col min-h-screen sticky top-0 self-start h-screen text-white transition-[width] duration-200`} style={{ backgroundImage: SIDEBAR_GRAD }}>
      {/* Logo */}
      <div className={`px-4 py-5 flex items-center ${collapsed ? "justify-center" : "justify-between"} gap-2`}>
        {!collapsed && (
          <div className="flex items-center gap-3 pl-1">
            <div className="w-9 h-9 rounded-xl flex items-center justify-center bg-white/10 backdrop-blur-sm ring-1 ring-white/10">
              <Icon name="cap" size={18} />
            </div>
            <span className="font-bold tracking-tight text-[16px]">Edestia</span>
          </div>
        )}
        <button onClick={onToggleCollapse} title={collapsed ? "Expand menu" : "Collapse menu"}
          className="w-8 h-8 rounded-lg flex items-center justify-center bg-white/5 hover:bg-white/15 shrink-0 transition-colors">
          <Icon name={collapsed ? "menu" : "chevron-left"} size={15} />
        </button>
      </div>

      {/* Navigation */}
      <nav className="px-3 flex-1 space-y-1 mt-1">
        {items.map(item => {
          const act = active === item.key;
          return (
            <button key={item.key} onClick={() => onSelect(item.key)} title={item.label}
              className={`w-full flex items-center ${collapsed ? "justify-center" : "gap-3"} rounded-xl px-3 py-2.5 text-[13px] font-medium transition-all duration-150
              ${act
                ? "bg-white/15 text-white shadow-sm shadow-black/10 backdrop-blur-sm"
                : "text-indigo-200/70 hover:text-white hover:bg-white/8"
              }`}>
              <Icon name={item.icon} size={18} className={act ? "opacity-100" : "opacity-70"} />
              {!collapsed && <span>{item.label}</span>}
            </button>
          );
        })}
      </nav>

      {/* User footer */}
      <div className={`${collapsed ? "px-2 py-3" : "px-3 py-4"} border-t border-white/10`}>
        {collapsed ? (
          <div className="flex flex-col items-center gap-1 py-1">
            <div className="w-9 h-9 rounded-full bg-indigo-500/30 ring-1 ring-white/10 flex items-center justify-center text-xs font-bold text-white/90">
              {(user?.full_name || "?")[0].toUpperCase()}
            </div>
          </div>
        ) : (
          <div className="flex items-center gap-3 px-2 py-2 mb-1">
            <div className="w-9 h-9 rounded-full bg-indigo-500/30 ring-1 ring-white/10 flex items-center justify-center text-sm font-bold text-white/90 shrink-0">
              {(user?.full_name || "?")[0].toUpperCase()}
            </div>
            <div className="min-w-0">
              <div className="text-sm font-medium truncate">{user?.full_name}</div>
              <div className="text-[11px] text-indigo-300/60 capitalize">{user?.role_name || user?.role}</div>
            </div>
          </div>
        )}
        <button onClick={() => setChangePw(true)} title="Change password"
          className={`w-full flex items-center ${collapsed ? "justify-center" : "gap-3"} rounded-xl px-3 py-2 text-[13px] font-medium text-indigo-200/50 hover:text-white hover:bg-white/8 transition-colors`}>
          <Icon name="lock" size={15} />{!collapsed && "Change password"}
        </button>
        <button onClick={logout} title="Sign out"
          className={`w-full flex items-center ${collapsed ? "justify-center" : "gap-3"} rounded-xl px-3 py-2 text-[13px] font-medium text-indigo-200/50 hover:text-white hover:bg-white/8 transition-colors`}>
          <Icon name="logout" size={15} />{!collapsed && "Sign out"}
        </button>
        {changePw && <ChangePassword onClose={() => setChangePw(false)} />}
      </div>
    </aside>
  );
}
